
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"27","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M.003 0h21.161v25H.003z"}})]),_c('g',{attrs:{"transform":"translate(0 1)","fill":"none","fill-rule":"evenodd"}},[_c('mask',{attrs:{"id":"b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#a"}})]),_c('path',{attrs:{"d":"M8.775 8.79h2.197v2.99a6.567 6.567 0 00-4.771 2.91h9.231l.15-.284c.173-.331.388-.62.624-.897a6.563 6.563 0 00-3.77-1.745V5.86h2.198c2.827 0 5.127-2.3 5.127-5.127V0H16.1c-2.63 0-4.778 1.998-5.069 4.55a5.1 5.1 0 00-3.72-1.62H3.648v.732c0 2.827 2.3 5.127 5.127 5.127z","fill":"#BDBDBD","mask":"url(#b)"}}),_c('path',{attrs:{"d":"M19.954 13.236a3.471 3.471 0 00-3.075 1.86l-2.864 5.464H8.482v-1.475h4.647l1.536-2.92H4.497L0 20.309 4.668 25l1.839-1.52h9.279l5.378-10.244h-1.21z","fill":"#BDBDBD","mask":"url(#b)"}})])])
          )
        }
      }
    